export const addOpacity = (color, opacity) => {
  const match = /#[\da-fA-F]{6}(,|\)|$)/.exec(color);
  if (match) {
    const red = parseInt(color.slice(1, 3), 16);
    const green = parseInt(color.slice(3, 5), 16);
    const blue = parseInt(color.slice(5, 7), 16);
    return `rgba(${red}, ${green}, ${blue}, ${opacity})`;
  }
  return color;
};
